import React, { useContext, useEffect, useState } from "react";
import {
  ManagePayrollLayout,
  SearchableList,
  FieldDropSide,
  FieldTextarea,
  LoaderWrapper,
  FieldButtonGroup,
  MultiSelectDropdown,
  Dropside,
  DatePicker,
  UploadComponent,
} from "../../../components";
import { Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage, yupToFormErrors } from "formik";
import { get, isEmpty } from "lodash";
import {
  MANAGE_PAYROLL_ROUTES,
  managePayrollFormNames,
  formFields,
  getPathWithParam,
  getFlowBasedFormValues,
  required,
  toMultiSelectValueById,
  usDateFormat,
} from "../../../utils";
import { managePayrollStore, setManagePageLevelData } from "../../../contexts";
import { useRequest, useRouterParams } from "../../../abstracts";
import { fileUploadForPayrollAndCensus } from "../../../contexts/reducers/manage-payroll/actions";
import { getInputProfiles, getPlanList } from "../../../services";
import * as Yup from "yup";

const initialValues = {
  payrollDocument: [],
  isSFTP: false,
  isMultiplePlanOrPaydate: false,
  planId: null,
  payDate: null,
};

const UploadFileContainer = (props) => {
  const { state, dispatch } = useContext(managePayrollStore);
  const { flow } = useRouterParams();
  const formName = managePayrollFormNames.UPLOAD_FILE;
  const fields = formFields[formName];
  const apiData = get(state, "api", {});
  const [fileUploadRequired, setFileUploadRequired] = useState("");
  const [template, setTemplate] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [isActive, setisActive] = useState();
  const isLoading = get(apiData, "isFetching", true);
  const yesNoOptions = [
    {
      label: "Yes",
      value: true,
    },

    {
      label: "No",
      value: false,
    },
  ];
  const { response, loading, error } = useRequest({
    method: getInputProfiles,
  });
  useEffect(() => {
    getPlanList(0).then((response) =>
      setPlanList(
        response.map((item) => {
          return {
            label: item.rkPlanNumber,
            value: item.rkPlanNumber,
          };
        })
      )
    );
  }, []);

  useEffect(() => {
    response && setTemplate(response.filter((_) => _.isActive));
  }, [response]);
  function onSubmit(values, { setFieldError }) {
    if (
      values[fields.uploadCensusAndPayroll] != undefined &&
      values[fields.uploadCensusAndPayroll] != null &&
      values[fields.uploadCensusAndPayroll].length > 0
    ) {
      setFileUploadRequired("");
      const { history } = props;
      fileUploadForPayrollAndCensus(values, dispatch)
        .then((response) => {
          if (response.isSuccessful) {
            history.push(
              getPathWithParam({
                path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
              })
            );
          } else {
            setFileUploadRequired(response.errorMessage);
          }
        })
        .catch((error) => {
          throw error;
        });
      dispatch(
        setManagePageLevelData({
          formName: formName,
          fieldData: values,
        })
      );
    } else {
      setFileUploadRequired("FU002 : Please upload a valid file.");
    }
  }

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
    },
    {
      label: "Upload",
      variant: "primary",
      type: "submit",
    },
  ];
  const validationSchema = Yup.object().shape({
    [fields.payDate]: Yup.date()
      .nullable()
      .test(
        "date greater than 2",
        "FU011 : Pay Date cannot be more than 30 days in the future",
        (data) => {
          return (
            data <=
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate() + 30
            )
          );
        }
      ),
  });
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...getFlowBasedFormValues(get(state, formName, {}), flow),
      }}
      onSubmit={onSubmit}
      enableReinitialize
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        setErrors,
        values,
        ...rest
      }) => {
        return (
          <Form
            className="mb-20 h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePayrollLayout buttons={buttons} isLoading={isLoading}>
              {/* <p className="payroll-sub-heading">Upload files</p> */}
              <Field
                label="Template"
                name={fields.template}
                value={values[fields.template]}
                options={template.map((value) => ({
                  label: value.name,
                  value: value.id,
                }))}
                placeholder="Select Template"
                direction="rightSide"
                popupContent={
                  <SearchableList
                    label="Select Template"
                    options={template.map((value) => ({
                      label: value.name,
                      value: value.id,
                    }))}
                    onSelect={(value) => {
                      var data = template.find((val) => val.id === value);
                      setFieldValue(fields.inputType, data.inputType);
                      setFieldValue(fields.format, data.format);
                      setFieldValue(fields.template, value);
                      setFieldValue(fields.planId, null);
                      setFieldValue(fields.payDate, null);
                      setFieldValue(
                        fields.isMultiplePlanOrPaydate,
                        value < 7 || (value >= 86 && value <= 88) ? true : false
                      );
                      setisActive(false);
                      setErrors({});
                      setFileUploadRequired("");
                    }}
                    selectedValue={values[fields.template]}
                  />
                }
                validate={(value) => {
                  return [undefined, null, ""].includes(value)
                    ? "FU001 : Required"
                    : undefined;
                }}
                component={FieldDropSide}
                isRequired
              />
              {values.fileType &&
                !(
                  values.fileType < 7 ||
                  (values.fileType >= 86 && values.fileType <= 88)
                ) && (
                  <div className="mb-3">
                    <p className="p-0 mb-2 ft-12 fw-400">
                      Upload file with Multiple Plans/Pay Dates
                    </p>
                    <Form.Check
                      type="switch"
                      id={`custom-switch-1`}
                      label=""
                      checked={isActive}
                      style={{ height: "22px", width: "44px" }}
                      onChange={() => {
                        setisActive(!isActive);
                        setValues({
                          ...values,
                          [fields.isMultiplePlanOrPaydate]: !isActive,
                          [fields.planId]: null,
                          [fields.payDate]: null,
                        });
                        setErrors({});
                      }}
                    />
                  </div>
                )}
              {values.fileType &&
                !(
                  values.fileType < 7 ||
                  (values.fileType >= 86 && values.fileType <= 88)
                ) &&
                !isActive && (
                  <>
                    <Field
                      label="Plan ID"
                      name={fields.planId}
                      value={values[fields.planId]}
                      options={planList.map((e) => ({
                        label: e.label,
                        value: e.label,
                      }))}
                      placeholder="Select Plan ID"
                      direction="right"
                      popupContent={
                        <SearchableList
                          label="Select Plan ID"
                          options={planList.map((e) => ({
                            label: e.label,
                            value: e.label,
                          }))}
                          onSelect={(value) => {
                            setFieldValue(fields.planId, value);
                          }}
                          selectedValue={values[fields.planId]}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value) &&
                          !values.isMultiplePlanOrPaydate &&
                          !(
                            values.fileType < 7 ||
                            (values.fileType >= 86 && values.fileType <= 88)
                          )
                          ? "FU009 : Required"
                          : undefined;
                      }}
                      isRequired
                      component={FieldDropSide}
                      noLabelTransform
                    />
                    <Field
                      name={fields.payDate}
                      isRequired
                      label="Pay Date"
                      {...rest}
                      value={usDateFormat(values[fields.payDate])}
                      isDatePicker
                      onClear={() => setFieldValue(fields.payDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            setFieldValue(fields.payDate, value)
                          }
                          value={usDateFormat(values[fields.payDate])}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value) &&
                          !values.isMultiplePlanOrPaydate &&
                          !(
                            values.fileType < 7 ||
                            (values.fileType >= 86 && values.fileType <= 88)
                          )
                          ? "FU010 : Required"
                          : undefined;
                      }}
                      component={FieldDropSide}
                      noLabelTransform
                    />
                  </>
                )}
              <UploadComponent
                name={fields.uploadCensusAndPayroll}
                setFieldValue={setFieldValue}
                label="Upload census and payroll file"
                fileExtensions=".csv, .xlsx, .xls,.xml,.txt,.docx "
              />
              {
                <p
                  style={{
                    fontSize: "0.75rem",
                    marginTop: "0rem",
                    color: "#ff5050",
                  }}
                >
                  {fileUploadRequired}
                </p>
              }
              <Field
                name={fields.description}
                placeholder="Enter file description"
                label="Description"
                autoComplete="none"
                value={values[fields.description]}
                onChange={handleChange}
                component={FieldTextarea}
                size="md"
              />{" "}
            </ManagePayrollLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default UploadFileContainer;
